/** @deprecated Generador legacy — usar `pages/Warehouse/Guide`. Ver `../legacy/README.md`. */
import React, { useState } from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Card, CardBody, Container } from 'reactstrap';

//redux
import GuideForm from '../Forms/GuideForm';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { icon } from 'leaflet';
import { RESIDUE_GUIDE_EDIT_ENABLED } from '../../legacy/constants';

const GuideRegister = () => {
    const history = useNavigate();
    const { idGuide } = useParams();

    if (!RESIDUE_GUIDE_EDIT_ENABLED && idGuide) {
        return <Navigate to="/residue/guides" replace />;
    }
    const [title, setTitle] = useState('');
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Medio Ambiente', icon: 'icon-leaf' },
		{ to: '/residue/dashboard', label: 'Residuos', icon: 'icon-recycle' },
	];

    //Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
                    <BreadCrumb title={title} links={breadcrumbLinks} />
                    {/* <div className='modal-content border-0 mt-3'>
                        <Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
                            <NavItem>
                                <NavLink
                                    href='#'
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => {
                                        toggleTab('1');
                                    }}
                                >
                                    Información General
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href='#'
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => {
                                        toggleTab('2');
                                    }}
                                >
                                    Conversiones
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div> */}
                    <Card>
                        <CardBody>
                            <GuideForm
                                activeTab={activeTab}
                                handleChangeTitleForm={(newTitle) => {
                                    setTitle(newTitle);
                                }}
                                handleToggleModal={() => history('/residue/guides')}
                                requireGuideDetailRegisterList={true}
                            />
                        </CardBody>
                    </Card>
					
				</Container>
			</div>
		</React.Fragment>
	);
};

export default GuideRegister;
